// extracted by mini-css-extract-plugin
export var banner = "_ff-0";
export var closeButton = "_ff-2";
export var greenCheckmark = "_ff-3";
export var hereLink = "_ff-4";
export var titleIcon = "_ff-1";